import useSWR from 'swr';

export interface CryptoValuationMetric {
  period_label: string;
  pf_circulating: number;
  pf_fully_diluted: number;
  take_rate: number;
}

export interface CryptoValuationResponse {
  symbol: string;
  data: CryptoValuationMetric[];
}

export function useCryptoValuation(symbol: string) {
  return useSWR<CryptoValuationResponse>(`api:/market/crypto/${symbol}/valuation-multiples`);
}
